import React from 'react';
import { Section } from './ui/Section';
import { Button } from './ui/Button';
export function TourDates() {
  const shows = [{
    id: 1,
    date: 'JUN 26',
    venue: 'San Pedro City Fest',
    location: '8:00pm - 9:00pm',
    status: 'Free Access'
  }, {
    id: 2,
    date: 'JUN 27',
    venue: 'San Pedro City Fest',
    location: '10:00pm - 11:00pm',
    status: 'Free Access'
  }, {
    id: 3,
    date: 'JUl 03',
    venue: 'San Pedro City Fest',
    location: '8:00pm - 9:00pm',
    status: 'Free Access'
  }, {
    id: 4,
    date: 'JUL 04',
    venue: 'San Pedro City Fest',
    location: '8:00pm - 9:00pm',
    status: 'Free Access'
  }];
  return <Section id="tour" className="bg-tx-midnight" data-id="element-160">
      <div className="flex flex-col md:flex-row md:items-end justify-between mb-16 gap-6" data-id="element-161">
        <div data-id="element-162">
          <h2 className="text-5xl md:text-7xl text-tx-parchmentLight uppercase" data-id="element-163">
            Live <span className="text-tx-whiskey" data-id="element-164">Shows</span>
          </h2>
          <p className="text-tx-parchmentLight/60 font-body text-lg mt-4 max-w-2xl" data-id="element-165">
            Catch us on the road. Grab your tickets before they're gone.
          </p>
        </div>
      </div>

      <div className="border-t-2 border-tx-saddle" data-id="element-166">
        {shows.map(show => <div key={show.id} className="group flex flex-col md:flex-row md:items-center justify-between py-8 border-b border-tx-saddle hover:bg-tx-saddle/20 transition-colors px-4 -mx-4 md:px-6 md:-mx-6" data-id="element-167">
            <div className="flex flex-col md:flex-row md:items-center gap-4 md:gap-12 lg:gap-24 mb-6 md:mb-0" data-id="element-168">
              <div className="font-heading text-4xl md:text-5xl text-tx-whiskey tracking-wider w-32 uppercase" data-id="element-169">
                {show.date}
              </div>
              <div data-id="element-170">
                <h3 className="font-heading text-3xl text-tx-parchmentLight tracking-wider group-hover:text-tx-blue transition-colors uppercase" data-id="element-171">
                  {show.venue}
                </h3>
                <p className="text-tx-parchmentLight/60 font-body text-lg mt-1" data-id="element-172">
                  {show.location}
                </p>
              </div>
            </div>

            <div className="flex items-center gap-6" data-id="element-173">
              {show.status === 'Sold Out' ? <span className="font-heading text-2xl text-tx-saddle tracking-widest uppercase" data-id="element-174">
                  Sold Out
                </span> : <Button variant="outline" className="w-full md:w-auto group-hover:border-tx-blue group-hover:text-tx-blue group-hover:bg-transparent" data-id="element-175">
                  {show.status}
                </Button>}
            </div>
          </div>)}
      </div>

      <div className="mt-12 text-center" data-id="element-176">
        <p className="text-tx-parchmentLight/50 font-body italic" data-id="element-177">
          More dates to be announced soon.
        </p>
      </div>
    </Section>;
}